module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('vue-antiscroll', {
    attrs: {
      "height": 300
    }
  }, [_c('ul', _vm._l((_vm.arr), function(item) {
    return _c('li', [_vm._v("\n            " + _vm._s(item.name) + "\n        ")])
  }))])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-480ac1de", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-480ac1de","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app.vue
// module id = 46
// module chunks = 0